export var Match = 1;
export var MatchPoints = 2;
export var FirstPeriod = 3;
export var SecondPeriod = 4;
export var ThirdPeriod = 5;
export var FourthPeriod = 6;
export var FifthPeriod = 7;
export var SixthPeriod = 8;
export var SeventhPeriod = 9;
export var EighthPeriod = 10;
export var TennisServe = 40;
export var RedCard = 41;
export var Penalty = 42;
export var YellowCard = 43;
export var CurrentGame = 44;
export var PowerPlay = 45;
export var Feed = 46;
export var Overtime = 47;
export var Corner = 48;
export var BallPossession = 49;
export var Timeout = 50;
export var FirstPeriodFouls = 51;
export var SecondPeriodFouls = 52;
export var ThirdPeriodFouls = 53;
export var FourthPeriodFouls = 54;
export var PenaltySeries = 55;
export var ExtraTime = 56;



// WEBPACK FOOTER //
// ./src/constants/ScoreType.js